import {
	Component,
	forwardRef,
	Input,
	OnInit,
	ViewChild,
	ChangeDetectionStrategy,
} from "@angular/core"
import { COMMON_IMPORTS } from "../common-imports"
import { GenTableComponent } from "@app/gen-table/gen-table.component"
import { Modalable } from "@app/Modalable"
import { LangValPipe } from "@app/utils/lang-val.pipe"
import { ModalWrapComponent } from "@app/modal-wrap/modal-wrap.component"
import { UploadDocumentComponent } from "@app/upload-document/upload-document.component"
import { AddDocumentComponent } from "@app/add-document/add-document.component"

@Component({
	selector: "app-user-documents",
	imports: [
		COMMON_IMPORTS,
		forwardRef(() => GenTableComponent),
		LangValPipe,
		ModalWrapComponent,
		UploadDocumentComponent,
		AddDocumentComponent,
	],
	changeDetection: ChangeDetectionStrategy.Eager,
	template: `
		<app-gen-table
			#documentsTable
			filterField="user_id"
			[filterFieldValue]="objectRow.id"
			tableName="documents"
		>
			<div class="row">
				<div
					class="col-12"
					style="text-align: end"
				>
					<button
						titleLang="letter"
						tabindex="-1"
						class="btn btn-primary"
						(click)="modalProps = { name: 'add-document' }"
						postIcon="plus"
					>
						{{ "letter" | langVal }}
					</button>
					<button
						titleLang="upload_file"
						tabindex="-1"
						class="btn btn-primary"
						(click)="modalProps = { name: 'upload-document' }"
						postIcon="plus"
					>
						{{ "upload_file" | langVal }}
					</button>
				</div>
			</div>
		</app-gen-table>
		@switch (modalProps?.name) {
			@case ("upload-document") {
				<app-modal-wrap
					(onClose)="modalProps = null"
					title="upload_file"
				>
					<app-upload-document
						(onClose)="modalProps = null"
						[user_id]="objectRow.id"
					/>
				</app-modal-wrap>
			}
			@case ("add-document") {
				<app-modal-wrap
					(onClose)="modalProps = null"
					title="letter"
					modalWrapperClass="modal-800"
				>
					<app-add-document
						(onClose)="modalProps = null"
						[user_id]="objectRow.id"
						[title]="objectRow.name"
					/>
				</app-modal-wrap>
			}
		}
	`,
})
export class UserDocumentsComponent extends Modalable {
	modalProps: any = null
	@Input() objectRow: any = null
	@ViewChild("documentsTable") documentsTable?: GenTableComponent
	userAddListener: any = null

	ngOnDestroy() {
		this.userAddListener?.unsubscribe()
	}
	ngOnInit() {
		this.userAddListener?.unsubscribe()
		this.userAddListener = this.store.userAddSubj.subscribe((res: any) => {
			if (res.user_id != this.objectRow.id) {
				return
			}
			this.documentsTable?.getItems()
		})
	}
}
